import Headings from "../../../components/Texts/Headings";
import ActiveLoanCard from "./ActiveLoanCard";
const ActiveLoanComponent = ({ activeLoans }) => {
  return (
    <div className="flex flex-col gap-[20px]">
      <Headings
        variant="LoanHeading"
        text="UPCOMING"
      />

      {activeLoans?.map((item, index) =>
        item?.type == "upcoming" ?
          <ActiveLoanCard {...item} /> : ""
      )}
      <Headings
        variant="LoanHeading"
        text="ALL LOANS"
      />
      {activeLoans?.map((item, index) => <ActiveLoanCard {...item} />)}
    </div>)
}
export default ActiveLoanComponent;